var cssRGBfromArray = function (c) {
    c = 'rgb(' + c[0] + ', ' + c[1] + ', ' + c[2] + ')';
    return c;
};

var pickFromGradient = function (color1, color2, weight) {
    var w = weight * 2 - 1;
    var w1 = (w + 1) / 2;
    var w2 = 1 - w1;
    return [Math.round(color1[0] * w1 + color2[0] * w2),
        Math.round(color1[1] * w1 + color2[1] * w2),
        Math.round(color1[2] * w1 + color2[2] * w2)];
};

var pickColor = function ($element, percent) {

    var gradient = [];

    var bg = $element.css('background-image');
    var regex = /rgb\((\d*), (\d*), (\d*)\) (\d*)%/g;
    var s = regex.exec(bg);
    while (s != null) {
        gradient.push([s[4], [s[1], s[2], s[3]]]);
        s = regex.exec(bg);
    }

    var colorRange = [];
    $.each(gradient, function (index, value) {
        if (percent <= gradient[index + 1][0] / 100.0) {
            colorRange = [index, index + 1];
            return false;
        }
    });

    //Get the two closest colors
    var g1 = gradient[colorRange[0]];
    var g2 = gradient[colorRange[1]];
    var firstcolor = g1[1];
    var secondcolor = g2[1];

    //Get the color with pickFromGradient(thx, less.js's mix function!)
    var adjustedPercent = (percent * 100 - g1[0]) / (g2[0] - g1[0]);
    return pickFromGradient(secondcolor, firstcolor, adjustedPercent);
};

var isLoggedIn = function () {
    return window.account_info.get_spa_id();
};

var windowLocationSearchParams = decodeURIComponent(window.location.search.slice(1))
    .split('&')
    .reduce(function _reduce(/*Object*/ a, /*String*/ b) {
        b = b.split('=');
        a[b[0]] = b[1];
        return a;
    }, {});


var autoFocusTextBox = function ($textbox) {
    'use strict';

    var element = $textbox[0];
    var firstTap = true;

    function selectInputText() {
        if (element.setSelectionRange) {
            element.setSelectionRange(0, element.value.length);
        } else {
            element.value = element.value; // This is probably a workaround for some weird browser
        }
        return false;
    }

    if (BROWSER_DETECTION_MODULE.ios) {
        $textbox.on('touchstart', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $textbox.focus().click();
            if (firstTap) {
                selectInputText();
                firstTap = false;
            }
            else {
                element.setSelectionRange(element.value.length, element.value.length);
            }
        });
    } else {
        $textbox.each(selectInputText);
    }
};

var intFormat = function (int) {
    return int.toLocaleString(document.documentElement.lang);
};
var getInt = function (str) {
    var stripped = str.replace(/\D/g, '');
    return parseInt(stripped);
};

export {autoFocusTextBox};
